module.exports = __webpack_public_path__ + "img/768_stores_img6.830d6afd.png";